const headerClient = algoliasearch('T3ODYTC4CT','d86df99f71dbffd2d6ce8b9700d9855c').initIndex('wa-shopify_products_search');
const headerClient2 = algoliasearch('T3ODYTC4CT','d86df99f71dbffd2d6ce8b9700d9855c').initIndex('wa-shopify_articles');
const headerClient3 = algoliasearch('T3ODYTC4CT','d86df99f71dbffd2d6ce8b9700d9855c').initIndex('wa-shopify_collections');
let autocompleteContainer = window.innerWidth > 640 ? $("#header_autocomplete") : $("#header_autocomplete_mobile");


$('.autocomplete-close').on('click', function(e){
    e.preventDefault();
    $('.header_right .header-search,.popup-modal-mobile-search .header-search').val("");
    autocompleteContainer.html("");
    autocompleteContainer.hide();
    document.body.classList.remove('algolia-header-popup-show');
    //document.querySelector(".search-bar .header-search").blur();
    // document.querySelector('body.search-open') && document.querySelector('body.search-open').classList.remove('search-open');
    $('.autocomplete-close').hide();
});
// $('.header_right .header-search,.popup-modal-mobile-search .header-search input').on("focus", function() {
//     document.body.classList.add('search-open');
// })
$('.header_right .header-search,.popup-modal-mobile-search .header-search').on("input", function() {

    
    // inputprocess($(this).val());

  if($(this).val().length > 2){
    $('.autocomplete-close').show();

    headerClient
        .search($(this).val(), {
            hitsPerPage: 4
          })
        .then(({ hits }) => {
            
            console.log('hit',hits);
            // let autolist = $(`<ul class="autocomplete_results"></ul>`);
            let autolist = $(`<ul class="autocomplete_results"></ul>`);
            document.querySelectorAll('.mega-nav.open, .brands.open').forEach((ele) => ele.classList.remove('open'));
            hits.forEach((hit) => {
                let prod_image = "https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg";
                let prod_title = hit.title;
                if(window.routes.rootUrlWithoutSlash == "/en"){
                    if(hit.meta.algolia && hit.meta.algolia.translation && hit.meta.algolia.translation[0] && hit.meta.algolia.translation[0].title){
                        prod_title = hit.meta.algolia.translation[0].title;
                    }
                }
                if(hit.image){
                    prod_image = hit.image;
                }
                // var unit_value = 'ft';
                // if(hit.meta.custom.unit){
                //     unit_value = hit.meta.custom.unit;
                // }
                // if(hit.variant_title.indexOf('Spool') > -1){
                //     var set_price = hit.variants_min_price;
                //     var store_split = hit.variant_title.split('/');
                //     if(store_split[0].indexOf('Spool') > -1){
                //       set_price = Number(Number(set_price/Number(store_split[0].split('ft')[0].trim())).toFixed(2));
                //     }else{
                //       set_price = Number(Number(set_price/Number(store_split[1].split('ft')[0].trim())).toFixed(2));
                //     }
                // }else{
                //     var set_price = hit.variants_min_price;
                // }

                // if(hit.variant_count > 1){
                //     var from_html = `From `;
                // }else{
                //     var from_html = ``;
                // }

                var set_price = hit.variants_min_price;                

                if(hit.tags.includes('multi-value') && hit.variants_min_price < hit.variants_max_price){
                  var from_html = `<span class="from">From </span>`;
                }else{
                  var from_html = ``;
                }

                var unit_value = 'ea.';
                if(hit.meta.custom.unit){
                  unit_value = hit.meta.custom.unit;
                }
                if(hit.variant_title == 'By the Foot'){
                  var unit_value = 'ft.';
                }
                var price_html = `<div class="price">${from_html}${window.formatMoney(set_price * 100, window.Shopify.money_format)}/${unit_value}</div>`;
                if(hit.tags.indexOf('quote') > -1){
                    price_html = `<a class="price" href="tel:18332688644">Call for Price</a>`;
                }
                autolist.append(`
                <li class="autocomplete_result">
                    <div class="autocomplete_image"> <img src="${prod_image}" height="100" loading="lazy" width="100" alt="product"> </div>
                    <div class="content"> <a href="${window.routes.rootUrlWithoutSlash}/products/${hit.handle}" class="autocomplete_title h5">${prod_title}</a>
                        ${price_html}
                    </div>
                </li>`);
            });
            //autocompleteContainer.html(`<div class="autocomplete_label">Suggestions...</div>`);
            if(hits.length > 0){
                autocompleteContainer.find('.search-products-blogs .search-product .autocomplete_label').empty().append(`${hits.length} Products`);
                autocompleteContainer.find('.search-products-blogs .search-product .autocomplete_results').empty().append(autolist.html());
                autocompleteContainer.find('.search-products-blogs .search-product .view-all-links').addClass('hide');
            }else{
                autocompleteContainer.find('.search-products-blogs .search-product .autocomplete_label').empty().append(`${hits.length} Products`);
                autocompleteContainer.find('.search-product .autocomplete_results.grid').empty().append(`<div class="autocomplete_noresults">No Results Found</div>`);
                autocompleteContainer.find('.search-products-blogs .search-product .view-all-links').addClass('hide');
            }
            autocompleteContainer.show();
            document.body.classList.add('algolia-header-popup-show')
        })
        .catch(err => {
            console.log(err);
        });

    headerClient2
        .search($(this).val(), {
            hitsPerPage: 2
          })
        .then(({ hits }) => {
            
            console.log('hit2',hits);
            let autolist = $(`<ul class="autocomplete_results"></ul>`);
            document.querySelectorAll('.mega-nav.open, .brands.open').forEach((ele) => ele.classList.remove('open'));
            hits.forEach((hit) => {
                let prod_image = "https://cdn.shopify.com/s/files/1/0576/7803/7155/files/imageless.jpg";
                let prod_title = hit.title;
                if(window.routes.rootUrlWithoutSlash == "/en"){
                    if(hit.meta.algolia && hit.meta.algolia.translation && hit.meta.algolia.translation[0] && hit.meta.algolia.translation[0].title){
                        prod_title = hit.meta.algolia.translation[0].title;
                    }
                }
                if(hit.image){
                    prod_image = hit.image;
                }
                var check_date = new Date(hit.created_at);
                const monthNames = [
                    "January", "February", "March", "April", "May", "June",
                    "July", "August", "September", "October", "November", "December"
                  ];
                autolist.append(`
                    <li class="autocomplete_result">
                        <div class="article-wrap">
                            <div class="content"> <a href="/blogs/${hit.blog.handle}/${hit.handle}" class="autocomplete_title h5">${hit.title}</a>
                                <div class="blog-date">${monthNames[check_date.getMonth()]} ${check_date.getDate()}, ${check_date.getFullYear()}</div>
                            </div> <a href="/blogs/${hit.blog.handle}/${hit.handle}" class="read-more">Read More</a> </div>
                    </li>`);
            });
            //autocompleteContainer.html(`<div class="autocomplete_label">Suggestions...</div>`);
            if(hits.length > 0){
                autocompleteContainer.find('.search-products-blogs .search-article .autocomplete_label').empty().append(`${hits.length} Articles`);
                autocompleteContainer.find('.search-products-blogs .search-article .autocomplete_results').empty().append(autolist.html());
                autocompleteContainer.find('.search-products-blogs .search-article .view-all-links').addClass('hide');
            }else{
                autocompleteContainer.find('.search-products-blogs .search-article .autocomplete_label').empty().append(`${hits.length} Articles`);
                autocompleteContainer.find('.search-products-blogs .search-article .autocomplete_results.grid').empty().append(`<div class="autocomplete_noresults">No Results Found</div>`);
                autocompleteContainer.find('.search-article .search-products-blogs .search-article .view-all-links').addClass('hide');
            }
            autocompleteContainer.show();
            document.body.classList.add('algolia-header-popup-show')
        })
        .catch(err => {
            console.log(err);
        });

        headerClient3
        .search($(this).val(), {
            hitsPerPage: 5
          })
        .then(({ hits }) => {
            
            console.log('hit3',hits);
            let autolist = $(`<ul class="autocomplete_results"></ul>`);
            document.querySelectorAll('.mega-nav.open, .brands.open').forEach((ele) => ele.classList.remove('open'));
            hits.forEach((hit) => {
                autolist.append(`
                    <li><a href="/collections/${hit.handle}">${hit.title}</a></li>`);
            });
            //autocompleteContainer.html(`<div class="autocomplete_label">Suggestions...</div>`);
            if(hits.length > 0){
                autocompleteContainer.find('.search-category .autocomplete_results').empty().append(autolist.html());
            }else{
                autocompleteContainer.find('.search-category .autocomplete_results').empty().append(`<div class="autocomplete_noresults">No Results Found</div>`);
            }
            autocompleteContainer.show();
            document.body.classList.add('algolia-header-popup-show')
        })
        .catch(err => {
            console.log(err);
        });

        


    
  }else{
    $('.autocomplete-close').hide();
    //autocompleteContainer.html("");
    autocompleteContainer.hide();
  }

  
});
